import React, {Component} from "react";
import axios from "axios";
import OdooService from "../services/odoo.service";
import ParamsService from "../services/params.service";
import Progressbar from "../common/progress_bar";
import typeCb from "../img/type_cb.jpg";
import jwtDecode from "jwt-decode";
import moment from 'moment';
import {format} from "date-fns";
const  tokenLink = ParamsService.$_GET("token");
const API_URL = process.env.REACT_APP_URL_API;
const USER_NAME_DEFAULT = process.env.REACT_APP_USER_NAME_DEFAULT;
const USER_PWD_DEFAULT = process.env.REACT_APP_USER_PWD_DEFAULT;
const dateCurrent = new Date();
const tokentime = format(new Date(), "dd/MM/yyyy hh:mm:ss");

//Partie config mulesoft
const API_URL_MULE = process.env.REACT_APP_URL_API_MULE;
const AUTHORIZATION_USERNAME = process.env.REACT_APP_URL_API_MULE_USERNAME;
const AUTHORIZATION_PASSWORD = process.env.REACT_APP_URL_API_MULE_PASSWORD;
const authToken = btoa(`${AUTHORIZATION_USERNAME}:${AUTHORIZATION_PASSWORD}`);

export default class PaymentCb extends Component {
    constructor(props) {
        super(props);
        this.disableBack = this.disableBack.bind(this);
        this.reloadPage = this.reloadPage.bind(this);
        this.state = {
            dataPayment: "",
            totalDebts: false,
            dunningActif: false,
            disableAt:"",
            loading:true,
            etape:0,
            error:false,
            pp1:false,
            anticip:false,
            iframeloading:false
        }
    }

    loginDefault(tokenlink) {
        var path="login_check";
        var uri = API_URL;
        if(process.env.REACT_APP_MULE==="1") {
            axios.defaults.headers.common['Authorization'] = `Basic ${authToken}`;
            path = "login";
            uri = API_URL_MULE;
        }

        return axios
            .post(uri + path, {
                "username": USER_NAME_DEFAULT,
                "password": USER_PWD_DEFAULT
            }, {mode: 'cors', credentials: 'include'})
            .then(response => {
                if (response.data.token) {
                    this.setState({etape:this.state.etape+20});
                    const token = response.data.token;
                    let user = [];
                    user = jwtDecode(token);
                    user['useremail'] = response.data.email;
                    user['userid'] =  response.data.user_id;
                    user['role'] = response.data.roles;
                    localStorage.setItem("user", JSON.stringify(user));
                    localStorage.setItem("token", token);
                    localStorage.setItem("tokenlink", tokenlink);
                    if(token) {
                        this.getIframeWorldlineCb(token,tokenlink);
                    }
                }
            },error => {
                this.setState({error:true});
            });
    }

    getIframeWorldlineCb(token,tokenlink){
        this.setState({iframeloading:true});
        return axios.get(
            API_URL + 'worldline/cb/iframe/'+tokenlink,
            {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }).then(
            response => {
                localStorage.setItem("hostedTokenizationUrl", response.data.hostedTokenizationUrl);
                localStorage.setItem("API_URL", API_URL);
                this.setState({iframeloading:false});
            },
            error => {
                this.setState({error:true});
                this.setState({iframeloading:false});
            }
        );
    }


    disableBack() {
        window.history.pushState(null, null, window.location.href);
        window.addEventListener('popstate', function (event) {
            window.history.pushState(null, null, window.location.href);
        });
    }

    componentDidMount() {
        localStorage.removeItem("amount");

        localStorage.setItem("tokentime", tokentime);

        if(tokenLink){
            this.loginDefault(tokenLink);
        }

        this.interval = setInterval(() => {
            this.reloadPage();

        }, 1000); // Exécute la fonction toutes les secondes (1000ms)


    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    reloadPage() {
        if(tokentime !== localStorage.getItem("tokentime")) {
            // Mettez le code de votre fonction ici
            window.location.reload();
            //alert("recharger ta page svp");
        }
    }

    render() {

        return ( <>

                {
                    (this.state.error) && (
                        <header className="jumbotron">
                            <h3>Notre partenaire de paiement a rencontré un léger problème. Veuillez actualiser la page dans quelques secondes. </h3>
                        </header>
                    )

                }
                {
                    (this.state.iframeloading) ? (
                        <header className="jumbotron">
                            <h3>Chargement en cours..... </h3>
                        </header>
                    ):(!this.state.error ) && (
                        <iframe id="iframeWorldline" className="iframe_all_payment"  onLoad={this.disableBack} title={"Iframe Worldline"} src="../../iframeFile/iframe_payment.html" ></iframe>
                    )

                }


            </>

        );
    }

}
